import { Component, ComponentFactoryResolver, Inject, Injector, OnInit, Type, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent, FeatureFlagService } from '@rubii/frontend-common';
import { GoogleUserProfileInterface } from '../interfaces/GoogleUserProfileInterface';
import { GoogleAgencyInterface } from '../interfaces/GoogleAgencyInterface';
import { DatasourceDirective } from '../datasource/directives/datasource.directive'
import { BaseDatasourceComponent } from '../datasource/base-datasource/base-datasource.component';
import { Dictionary } from '@rubii/share/src/types';

@Component({
    selector: 'app-datasource-connection',
    templateUrl: './datasource-connection.component.html',
    styleUrls: ['./datasource-connection.component.scss']
})
export class DatasourceConnectionComponent extends BaseComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { 
            dataSourceId: number, 
            dataSourceClass: 
            Type<BaseDatasourceComponent>, 
            networks: Dictionary[],
            userProfilesOrAgencies: GoogleUserProfileInterface[] | GoogleAgencyInterface[], 
            enabledDatasourceId: number,
            userDataStudioToken?: string,
            dataSourceLogo?: string,
        }, private injector: Injector,
            private feature: FeatureFlagService,
        ) {
        super();
    }

    @ViewChild(DatasourceDirective, { static: true })
    dataSourceHost: DatasourceDirective;

    ngOnInit() {
        this.connect();
    }

    connect() {
        const injector = Injector.create({
            providers: [{ provide: MAT_DIALOG_DATA, useValue: this.data }],
            parent: this.injector,
        });
        
        const viewContainerRef = this.dataSourceHost.viewContainerRef;
        viewContainerRef.clear();
        viewContainerRef.createComponent(this.data.dataSourceClass, { injector });
    }
}
